import { apiBlobRequest, apiRequest } from '../api/http'
import type {
  ChannelStockAllocationRule,
  ChannelStockAllocationRuleUpdateRequest,
  StockAllocationItemPage,
  StockAllocationItemStatus,
  StockAllocationRunDetail,
  StockAllocationRunSummary,
  StockAllocationTargetLocation,
} from './types'

const CHANNELS_BASE = '/api/channels'

function stockAllocationAuth(accessToken: string) {
  return { accessToken }
}

export function listStockAllocationRules(accessToken: string): Promise<ChannelStockAllocationRule[]> {
  return apiRequest<ChannelStockAllocationRule[]>(CHANNELS_BASE, '/stock-allocation-rules', stockAllocationAuth(accessToken))
}

export function listStockAllocationTargetLocations(accessToken: string): Promise<StockAllocationTargetLocation[]> {
  return apiRequest<StockAllocationTargetLocation[]>(CHANNELS_BASE, '/stock-allocation-target-locations', stockAllocationAuth(accessToken))
}

export function saveStockAllocationRule(
  accessToken: string,
  channelConnectionId: number,
  payload: ChannelStockAllocationRuleUpdateRequest,
): Promise<ChannelStockAllocationRule> {
  return apiRequest<ChannelStockAllocationRule>(
    CHANNELS_BASE,
    `/${channelConnectionId}/stock-allocation-rule`,
    { method: 'PUT', body: payload, accessToken },
  )
}

export function listStockAllocationRuns(accessToken: string, size = 50, connectionId?: number): Promise<StockAllocationRunSummary[]> {
  const search = new URLSearchParams({ size: String(size) })
  if (connectionId != null) search.set('connectionId', String(connectionId))
  return apiRequest<StockAllocationRunSummary[]>(CHANNELS_BASE, `/stock-allocation-runs?${search}`, stockAllocationAuth(accessToken))
}

export function getStockAllocationRun(accessToken: string, runId: number): Promise<StockAllocationRunDetail> {
  return apiRequest<StockAllocationRunDetail>(CHANNELS_BASE, `/stock-allocation-runs/${runId}`, stockAllocationAuth(accessToken))
}

export function listStockAllocationRunItems(
  accessToken: string,
  runId: number,
  params: { status?: StockAllocationItemStatus; code?: string; query?: string; page?: number; size?: number } = {},
): Promise<StockAllocationItemPage> {
  const search = new URLSearchParams()
  if (params.status) search.set('status', params.status)
  if (params.code) search.set('code', params.code)
  if (params.query) search.set('query', params.query)
  search.set('page', String(params.page ?? 0))
  search.set('size', String(params.size ?? 50))
  return apiRequest<StockAllocationItemPage>(CHANNELS_BASE, `/stock-allocation-runs/${runId}/items?${search}`, stockAllocationAuth(accessToken))
}

export function retryFailedStockAllocationItems(accessToken: string, runId: number): Promise<StockAllocationRunDetail> {
  return apiRequest<StockAllocationRunDetail>(CHANNELS_BASE, `/stock-allocation-runs/${runId}/retry-failed`, {
    accessToken,
    method: 'POST',
  })
}

export function downloadStockAllocationReport(accessToken: string, runId: number) {
  return apiBlobRequest(CHANNELS_BASE, `/stock-allocation-runs/${runId}/report.csv`, stockAllocationAuth(accessToken))
}
